export default __webpack_public_path__ + "DOE_logo.png";